module.exports = __webpack_public_path__ + "img/widgets.0b996e65.png";